import React from 'react'
import AddBrandContainer from '../../../../Components/Brand/AddBrandContainer/AddBrandContainer'
import Layout from '../../Layout'

const AddBrand = () => {
  return (
    <Layout><AddBrandContainer/></Layout>
  )
}

export default AddBrand